import type { QuerySpec } from '@helios/powersync-client-core';

export * from './prescription-print-settings-logic.js';

// ─── Queries ───

/** Fetch the org-default Prescription Print Settings row (clinic_id IS NULL). */
export function qPrescriptionPrintSettings(): QuerySpec<[]> {
  return {
    key: ['prescription-print-settings'] as const,
    sql: `SELECT * FROM prescription_print_settings WHERE clinic_id IS NULL ORDER BY updated_at DESC LIMIT 1`,
    params: [],
    watch: ['prescription_print_settings'],
  };
}
